export enum AllocationTypes {
  sales = 'SALES',
  purchases = 'PURCH',
  // Mirrors AllocationTypes.TransferRequest in the API.
  transferRequest = 'TRANSFER',
}
